export default {
    accessToken: import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: import.meta.env.VITE_APP_ENV,
        client: {
            javascript: {
                code_version: "1.0.0",
            },
        },
    },
};
